import ChatApp from './chat-app';
import r2wc from '@r2wc/react-to-web-component';

// <r2w-chat-app items='[{"namespace":"vidaone","building_id"130"}]' />
// const wcChatApp = r2wc(App, { shadow: "closed", props: { items: "json" } });
// const wcChatApp = r2wc(ChatApp, { props: { namespace: "string", buildingId: "string" } });
const wcChatApp = r2wc(ChatApp, { shadow: "open", props: ["namespace", "buildingId"] });

customElements.define("r2w-chat-app", wcChatApp);